import { Component, effect, inject, input, OnInit, output } from '@angular/core';

import { PREVIEW_MEDIA_STORE, SurveyConditionalService, SurveyNavigationService, SurveyViewerService, SurveyViewerStateService } from '@empathy/survey-viewer';

import { AdminSurveyPreviewNavigationService } from '../../services/admin-survey-preview-navigation.service';
import { PreviewMediaStore } from '../../services/preview-media-store.service';

@Component({
  selector: 'empathy-preview-viewer-host',
  templateUrl: 'preview-viewer-host.component.html',
  styleUrl: 'preview-viewer-host.component.scss',
  providers: [
    SurveyViewerService,
    SurveyConditionalService,
    SurveyViewerStateService,
    PreviewMediaStore,
    { provide: PREVIEW_MEDIA_STORE, useExisting: PreviewMediaStore },
    AdminSurveyPreviewNavigationService,
    { provide: SurveyNavigationService, useExisting: AdminSurveyPreviewNavigationService }
  ]
})
export class PreviewViewerHostComponent implements OnInit {
  authoredSurveyJson$ = input.required<string>({ alias: 'authoredSurveyJson' });
  generation$ = input.required<number>({ alias: 'generation' });
  languageCode$ = input('en-GB', { alias: 'languageCode' });
  replacesPreviewSessionId$ = input<string>(undefined, { alias: 'replacesPreviewSessionId' });
  variables$ = input<Record<string, string> | null>(null, { alias: 'variables' });

  busyChange = output<boolean>();
  restartRequested = output<void>();
  sessionCreated = output<string>();

  readonly navigationService = inject(AdminSurveyPreviewNavigationService);
  readonly error$ = this.navigationService.error$;
  readonly isBusy$ = this.navigationService.isBusy$;
  readonly previewRun$ = this.navigationService.previewRun$;

  private readonly surveyViewerService = inject(SurveyViewerService);

  constructor() {
    effect(() => this.busyChange.emit(this.isBusy$()));
  }

  ngOnInit(): void {
    this.surveyViewerService.isTestMode$.set(true);
    this.navigationService
      .start(this.authoredSurveyJson$(), this.variables$(), this.generation$(), this.languageCode$(), this.replacesPreviewSessionId$())
      .subscribe((previewSessionId) => this.sessionCreated.emit(previewSessionId));
  }

  onPreviewForceComplete(): void {
    this.navigationService.showCommunicationError();
  }

  onRestart(): void {
    if (!this.isBusy$()) {
      this.restartRequested.emit();
    }
  }
}
